import React, { useState, useEffect } from 'react';
import { LocationSummaryData } from '../../types';
import './LocationSummaryTile.scss';

interface LocationSummaryTileProps {
    location: LocationSummaryData;
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    isActive: boolean;
}

const LocationSummaryTile: React.FC<LocationSummaryTileProps> = ({ location, onClick, isActive }) => {

    const [isGrown, setIsGrown] = useState<boolean>(false);
    const [isShrunk, setIsShrunk] = useState<boolean>(true);

    const toggleGrowing = (): void => {
        if (isGrown) {
            setIsGrown(false);
            setIsShrunk(true);
        }
        else {
            setIsGrown(true);
            setIsShrunk(false);
        }
    };

    return (
        <div className={`location-summary-tile${isActive ? '-active' : ''}`} onClick={onClick}>
            <div className='location-summary-tile-header'>
                <div className='location-summary-tile-header-title'>
                    {location.name} ({location.abbreviation})
                </div>
                <div className='location-summary-tile-header-actions'>
                    <i className="fa-regular fa-ellipsis"></i>
                    {isGrown
                        ? <i className="fa-regular fa-arrow-left-from-line" onClick={toggleGrowing}></i>
                        : <i className="fa-regular fa-arrow-right-from-line" onClick={toggleGrowing}></i>
                    }
                </div>
            </div>
        </div>
    );
};

export default LocationSummaryTile;
